import React, { useState, useRef } from "react";
import { Carousel } from "antd";
import ReactPlayer from "react-player";

const RecipeMediaPost = ({ media }) => {
  const [currentSlide, setCurrentSlide] = useState(0); // Track the current slide
  const [isPlaying, setIsPlaying] = useState(false); // Track if a video is playing
  const carouselRef = useRef(null); // Reference to the carousel

  const handlePlay = (index) => {
    if (currentSlide === index) setIsPlaying(true); // Allow play only for the current slide
  };

  const handlePause = () => {
    setIsPlaying(false); 
  };

  const goToSlide = (index) => {
    setCurrentSlide(index); 
    carouselRef.current.goTo(index); 
    setIsPlaying(false); // Ensure video stops playing
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <div
        style={{
          width: "100%",
          maxWidth: "600px", 
          border: "1px solid #ddd",
          borderRadius: "8px",
          overflow: "hidden",
        }}
      >
        <Carousel
          ref={carouselRef} 
          autoplay={false}
          dots={false} // Disable default dots
          beforeChange={() => {
            setIsPlaying(false); 
          }}
        >
          {media?.map((item, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "450px",
                background: "#f9f9f9",
              }}
            >
              {item?.type === "IMAGE" ? (
                <div className="flex-center" style={{ height: "450px", width: "100%" }}>
                <img
                  src={item?.url}
                  alt={`Media ${index + 1}`}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain"
                  
                  }}
                />
                </div>
              ) : (
                <ReactPlayer
                  url={item?.url}
                  controls
                  width="100%"
                  height="450px"
                  style={{ backgroundColor: "#000" }}
                  playing={currentSlide === index && isPlaying} // Play only if the slide is active and isPlaying is true
                  onPlay={() => handlePlay(index)} 
                  onPause={handlePause} 
                />
              )}
            </div>
          ))}
        </Carousel>
      </div>

      {/* Custom Dots Section */}
      <div
        className="custom-carousel-dots"
        style={{
          marginTop: "16px", // Add space between the carousel and dots
          display: "flex",
          justifyContent: "center",
          gap: "8px",
        }}
      >
        {media?.map((_, index) => (
          <div
            key={index}
            style={{
              width: "15px",
              height: "15px",
              borderRadius: "50%",
              border: "1px solid black",
              backgroundColor: currentSlide === index ? "#000" : "", // Highlight active dot
              cursor: "pointer",
            }}
            onClick={() => goToSlide(index)} // Navigate to the specific slide on click
          ></div>
        ))}
      </div>
    </div>
  );
};

export default RecipeMediaPost;
